import { ClientsService } from '../services'

const SendBatchAction = (action, typeForm, period, ids, filters, isSendAll) => {
  return new Promise(async (resolve, reject) => {
    await ClientsService.sendBatchAction(action, typeForm, period, ids, filters, isSendAll)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
export default SendBatchAction